<div custom-links-bottom>
  <ul class="list-group-inset">
    @if (isLockedAgent) {
      <li>
        <b class="text-magenta" [innerHTML]="'close-tab-to-logout-text' | content"></b>
      </li>
    }
    @if (!isLockedAgent) {
      <li class="is-clickable">
        <a class="flex align-items-center justify-content-between" [appTrackingNav]="'Uitloggen'" (click)="logout()">
          <div>{{ 'logout' | content }}</div>
          <span class="icon-arrow-right"></span>
        </a>
      </li>
    }
  </ul>
</div>
